import EventEmitter from 'events';
import director from '../../director/director';
const TableViewContainerFactory=(manager, viewOptions)=>{
    let _emitter=new EventEmitter();
    let userTable = [];
    let featuresTable = [];
    //async functions
    const fetchUserTable= async ()=>{
        let result = await director.fetchTableUser();
        let data=[];
        if (result.status ==="ok"){
            data=result.data;
        }
        userTable=data;
        _emitter.emit('change-table');
    };
    const fetchFeaturesTable= async ()=>{
        let result = await director.fetchTableFeatures();
        let data=[];
        if (result.status ==="ok"){
            data=result.data;
        }
        featuresTable=data;
        _emitter.emit('change-table');
    };
    const getUserInfo = async (user)=>{
        console.log("in getUserInfo conainer ", user.user);
        let result = await director.fetchUserInfo(user.user);
        let data={};
        if (result.status==="ok"){
            data=result.data;
        }
        return data;
    };
    const newUser= async (userData)=>{
        let checkedData={};
        let insert=false;
        if(userData && userData.install_qty){
            checkedData.install_qty=parseInt(userData.install_qty);
        }
        checkedData.user=userData.user;
        checkedData.pass=userData.pass;
        insert=!userTable.includes(userData.user);
        if (insert){
            let result=await director.insertNewUser(checkedData);
            if (result.status ==="ok"){
                fetchUserTable();
            }
        }
    }
    const newFeature= async (feature)=>{
        let insert=!featuresTable.includes(feature.code);
        if (insert){
            let result=await director.insertNewFeature(feature);
            if (result.status ==="ok"){
                fetchFeaturesTable();
            }
        }
    }
    const deleteUser = async (userData)=>{
        let result = await director.deleteUser(userData);
        if (result.status==="ok"){
            fetchUserTable();
        }
    }
    const deleteSlot = async (user) =>{
        let result = await director.deleteSlot(user);
    }
    const deleteFeature = async (feature)=>{
        let result = await director.deleteFeature(feature);
        if (result.status === 'ok'){
            fetchFeaturesTable();
        }
    }
    const updateUserInfo = async (data)=>{
        let result = await director.updateUserData(data);
        if (result.status === "ok"){
            fetchUserTable();
        }
    }
    //events
    const on = (event, handler) => {
        _emitter.on(event, handler);
    }

    const off = (event, handler) => {
        _emitter.removeListener(event, handler);
    }

    const once = (event, handler) => {
        _emitter.once(event, handler);
    }
    // function
    const showGreeting=()=>{
        return "Welcome to the Table View";
    }
    const getUserTable =() =>{
        return userTable;
    }
    const getFeaturesTable = ()=>{
        return featuresTable;
    }
    
    return {
        message:showGreeting,
        getUserTable,
        getFeaturesTable,
        getUserInfo,
        fetchFeaturesTable,
        fetchUserTable,
        newUser,
        newFeature,
        deleteUser,
        deleteFeature,
        deleteSlot,
        updateUserInfo,
        on:on,
        off:off,
        once:once
    };
}
export default TableViewContainerFactory